import React from 'react';
import { connect } from 'react-redux';
import { editProcedure, addProcedure, saveProcedure, addProcedureToFunctionWorkflow, addAllProceduresToFunctionWorkflow, fetchGBUs } from '../../reduxActions/ProceduresActions';
import { updateFunctionCategories } from '../../reduxActions/FunctionsActions';
import { showSnackBarMessage } from '../../reduxActions/AppInfoActions';

import _ from 'lodash';

const ProceduresContext = React.createContext({});

class ProceduresStore extends React.Component {
    state = {
        procedureToConfirmArchive: null,
        procedureToConfirmRevision: null,
        shouldDisplayArchivedProcedures: false,
        categoriesDialogOpen: false,
        propertyToSortBy: 'sdn',
        sortReverse: true,
        searchText: "",
        categoryFilterText: "",
        statusFilterText: "",
    };

    componentDidMount() {
        this.props.fetchGBUs();
    }
    confirmArchive = procedureToConfirmArchive => this.setState({ procedureToConfirmArchive });
    confirmRevision = procedureToConfirmRevision => this.setState({ procedureToConfirmRevision });
    displayArchivedProcedures = shouldDisplayArchivedProcedures => this.setState({ shouldDisplayArchivedProcedures });
    displayCategoriesDialog = () => this.setState({ categoriesDialogOpen: true });
    closeCategoriesDialog = () => this.setState({ categoriesDialogOpen: false });

    setPropertyToSortBy = propertyToSortBy => {
        this.setState({ propertyToSortBy, sortReverse: (propertyToSortBy === this.state.propertyToSortBy && !this.state.sortReverse) });
    }

    sortProceduresList = proceduresList => {

        const sortedProcedures = _.sortBy(proceduresList, [this.state.propertyToSortBy, 'sdn']);

        return this.state.sortReverse ? sortedProcedures : _.reverse(sortedProcedures);

    }

    setSearchText = searchText => this.setState({ searchText });
    setCategoryFilterText = categoryFilterText => this.setState({ categoryFilterText });
    setStatusFilterText = statusFilterText => this.setState({ statusFilterText });

    render() {
        let canCurrentUserEditProcedures = false;
        if (this.props.isProjectSpecific) {
            canCurrentUserEditProcedures = !!_.find(this.props.aboutCurrentUser.approvalRoles, role => role.project === this.props.procedures.selectedProject.name && role.function === this.props.procedures.selectedProjectFunction.name);
        } else {
            //canCurrentUserEditProcedures = this.props.aboutCurrentUser.isOM || this.props.aboutCurrentUser.isAdmin;
            canCurrentUserEditProcedures = this.props.aboutCurrentUser.isAdmin;
        }

        if (this.props.aboutCurrentUser.isAdmin) {
            canCurrentUserEditProcedures = true;
        }

        if (this.props.isProjectSpecificCorporate) {
            canCurrentUserEditProcedures = false;
        }

        return (
            <ProceduresContext.Provider
                value={
                    {
                        ...this.state,
                        ...this.props,
                        confirmArchive: this.confirmArchive,
                        confirmRevision: this.confirmRevision,
                        displayArchivedProcedures: this.displayArchivedProcedures,
                        isProjectSpecific: this.props.isProjectSpecific,
                        isProjectSpecificCorporate: this.props.isProjectSpecificCorporate,
                        displayCategoriesDialog: this.displayCategoriesDialog,
                        closeCategoriesDialog: this.closeCategoriesDialog,
                        canCurrentUserEditProcedures,
                        sortProceduresList: this.sortProceduresList,
                        setPropertyToSortBy: this.setPropertyToSortBy,
                        setSearchText: this.setSearchText,
                        setCategoryFilterText: this.setCategoryFilterText,
                        setStatusFilterText: this.setStatusFilterText,
                    }
                }>
                {this.props.children}
            </ProceduresContext.Provider>

        );
    }
}

const mapStateToProps = state => {
    return {
        contentHeight: state.app.contentSize.height,
        procedures: state.procedures,
        aboutCurrentUser: state.app.aboutCurrentUser,
        selectedFunctionDetails: state.functions.selectedFunctionDetails,
        projectCategory: state.projects.selectedFunctionDetails ? state.projects.selectedFunctionDetails.projectCategory : undefined,
        // myRRDocs: state.functions.myRRDocs
    };
}

ProceduresStore = connect(mapStateToProps, { editProcedure, addProcedure, saveProcedure, addAllProceduresToFunctionWorkflow, addProcedureToFunctionWorkflow, updateFunctionCategories, showSnackBarMessage, fetchGBUs })(ProceduresStore);

export { ProceduresStore };


export default ProceduresContext;